exports = module.exports = require("../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hotel-image{background-size:cover;position:relative;height:100%;width:100%}.hotel-image__gallery-btn{cursor:pointer;position:absolute;top:10px;right:10px}.hotel-image--placeholder{background-size:contain!important;background-repeat:no-repeat;background-position-x:center;background-position-y:center}body[dir=rtl] .hotel-image__gallery-btn {\n  left: 10px;\n}\n", ""]);

// exports
